import * as React from 'react';

import { cn } from '../../lib/utils';

export type DialogActionsProps = React.HTMLAttributes<HTMLDivElement>;

export function DialogActions({ className, ...props }: DialogActionsProps) {
  return (
    <div
      className={cn('flex items-center justify-end gap-[0.6875rem]', className)}
      {...props}
    />
  );
}
